// Small display helpers shared by the Platform Admin screens (UX-046).

/** "user_login" / "permission.granted" → "User login" / "Permission granted".
 * Display only: the raw action name stays what filters, exports and the API use. */
export function humaniseAction(action: string | undefined | null): string {
  const words = (action ?? '').replace(/[_.\-:]+/g, ' ').replace(/\s+/g, ' ').trim()
  if (!words) return 'Unknown action'
  return words.charAt(0).toUpperCase() + words.slice(1).toLowerCase()
}

/** A user id as the reader should see it: their email when the directory knows
 * it, otherwise the id itself — never blank, never a made-up name. */
export function userLabel(userId: string | undefined | null, emailsById: Map<string, string>): string {
  if (!userId) return 'Unknown user'
  return emailsById.get(userId) ?? userId
}
